import { render } from "./MembersView.vue?vue&type=template&id=54052931&scoped=true"
import script from "./MembersView.vue?vue&type=script&lang=js"
export * from "./MembersView.vue?vue&type=script&lang=js"

import "./MembersView.vue?vue&type=style&index=0&id=54052931&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54052931"]])

export default __exports__